export const formatNumber = (number, minDecimalPlaces = 0) => {
  if (number === null || number === undefined) return '0';

  return new Intl.NumberFormat('es-AR', {
    minimumFractionDigits: minDecimalPlaces,
    maximumFractionDigits: 2,
  }).format(number || 0);
};

export const toNumericAmount = (amount) => {
  if (amount == null) return null;

  if (typeof amount === 'object') {
    if (amount.value != null) return toNumericAmount(amount.value);
    if (amount.formatted != null) return toNumericAmount(amount.formatted);
    return null;
  }

  if (typeof amount === 'number') {
    return Number.isFinite(amount) ? amount : null;
  }

  if (typeof amount === 'string') {
    const cleaned = amount.replace(/[$'\s]/g, '');
    if (!cleaned) return null;
    const parsed = parseLocaleNumber(cleaned);
    return Number.isFinite(parsed) ? parsed : null;
  }

  const numeric = Number(amount);
  return Number.isFinite(numeric) ? numeric : null;
};

export const parseLocaleNumber = (stringNumber) => {
  // Si está vacío retornamos 0
  if (!stringNumber) return 0;

  // Limpiamos el string de espacios
  const cleanString = stringNumber.replace(/\s/g, '');

  // Si tiene coma decimal pero no tiene punto de miles
  if (cleanString.includes(',') && !cleanString.includes('.')) {
    return parseFloat(cleanString.replace(',', '.'));
  }

  // Si tiene punto de miles y coma decimal
  if (cleanString.includes('.') && cleanString.includes(',')) {
    return parseFloat(cleanString.replace(/\./g, '').replace(',', '.'));
  }

  // Si solo tiene puntos (miles)
  if (cleanString.includes('.') && !cleanString.includes(',')) {
    return parseFloat(cleanString.replace(/\./g, ''));
  }

  // Si no tiene separadores
  return parseFloat(cleanString) || 0;
};
  
export const formatCurrency = (amount, minDecimalPlaces = 0) => {
  if (amount === null || amount === undefined) return '$0';
  
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: minDecimalPlaces,
    maximumFractionDigits: 2,
  }).format(amount);
}; 

export const formatPercentage = (value) => {
  if (value === null || value === undefined) return '-';
  
  return new Intl.NumberFormat('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value) + '%';
};

export const formatDate = (dateString) => {
  if (!dateString) return '';

  let date;
  
  // Si la fecha viene en formato ISO con timezone (2025-01-31T00:00:00.000000Z)
  if (dateString.includes('T')) {
    const iso = new Date(dateString);
    date = new Date(iso.getTime() + iso.getTimezoneOffset() * 60000);
  } else {
    // Normalizamos tomando solo la parte de fecha si hay hora
    const [datePart] = dateString.split(' ');

    // YYYY-MM-DD (con o sin hora)
    if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
      const [year, month, day] = datePart.split('-').map(Number);
      date = new Date(year, month - 1, day);
    }
    // DD-MM-YYYY (con o sin hora)
    else if (/^\d{2}-\d{2}-\d{4}$/.test(datePart)) {
      const [day, month, year] = datePart.split('-').map(Number);
      date = new Date(year, month - 1, day);
    }
  }

  // Verificamos si la fecha es válida
  if (isNaN(date.getTime())) {
    return dateString; // Retornamos el string original si la fecha es inválida
  }

  return date.toLocaleDateString('es-AR', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit'
  });
};
